<template>
  <img
    :src="`${basePath}/images/huayao2.jpg`"
    class="thumbnail"
    title="Observatorio de Huancayo"
    alt="Observatorio de Huancayo"
  />
  <p>
    El Observatorio de Huancayo (12°02'18''S, 75°19'22''W, 3350 msnm), a pocos
    kilómetros del poblado de Huayao, es la cuna del Instituto Geofísico del
    Perú. Fue fundado como “Observatorio Magnético de Huancayo” en 1922 por la
    fundación Carnegie en ese lugar debido a su cercanía al ecuador magnético.
    En 1947, con mayor capacidad y funciones, se convierte en el “Observatorio
    Geofísico de Huancayo” y, quince años después, se une con otras entidades
    para formar el Instituto Geofísico del Perú.
  </p>
  <p>
    Desde su inicio en 1922, este observatorio fue sede de importantes
    mediciones e investigaciones geofísicas, entre las cuales se encuentra la
    serie de mediciones climáticas más larga del país. Este largo historial hace
    que esta información sea crucial para el estudio del cambio climático en el
    Perú, mientras que su calidad y diversidad en cuanto a instrumental la hacen
    de utilidad para una gran variedad de estudios relacionados al clima.
  </p>
  <p>
    La facilidad de Microfísica Atmosférica y Radiación (LAMAR) del IGP tiene
    como objetivo mejorar la comprensión de los procesos físicos que afectan el
    clima de los Andes, para mejorar la capacidad de modelado necesario para la
    evaluación de los impactos futuros del cambio climático, así como apoyar en
    la validación de técnicas de sensoramiento remoto. Se basa en la serie
    climática larga (1921 - presente) de la estación meteorológica de Huayao
    como en sofisticados instrumentos especializados, como un radar perfilador
    de vientos, radiómetros de onda corta y larga, un anemómetro sónico, entre
    otros. Actualmente se están adquiriendo un radar perfilador de nubes y
    disdrómetros, que permitirán a LAMAR formar parte de la red de validación de
    la misión GPM, así como estudiar en profundidad la física de las
    precipitaciones en los Andes.
  </p>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13475127.667701505!2d-72.31836742709737!3d-11.313896908044285!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDAyJzE4LjAiUyA3NcKwMTknMjIuMCJX!5e0!3m2!1ses!2spe!4v1631317980902!5m2!1ses!2spe"
    width="100%"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
  ></iframe>
</template>
<script>
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath
    };
  }
};
</script>
